import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

export type P_SelectorForEdit<T extends string | number> =
	P_SelectorForEditBase<T> & {
		id: string;
		label: string;
		valueOutput?: (e: T) => any;
	};
export type P_SelectorForEditBase<T extends string | number> = {
	items: T[];
	onChange: (value: string) => any;
	value: string;
};

export default function SelectorForEdit<T extends string | number>(
	props: P_SelectorForEdit<T>,
) {
	const _onChange = React.useCallback(
		(event: SelectChangeEvent) => props.onChange(event.target.value),
		[],
	);

	const labelId = props.id + '-label';
	return (
		<FormControl fullWidth size='small'>
			<InputLabel id={labelId}>{props.label}</InputLabel>
			<Select
				labelId={labelId}
				id={props.id}
				value={props.value}
				label={props.label}
				onChange={_onChange}
			>
				{props.items.map((e, i) => {
					return (
						<MenuItem key={i} value={e}>
							{props.valueOutput ? props.valueOutput(e) : e}
						</MenuItem>
					);
				})}
			</Select>
		</FormControl>
	);
}
